import { render, staticRenderFns } from "./recurring-reminders.vue?vue&type=template&id=dc8d4da8"
import script from "./recurring-reminders.vue?vue&type=script&lang=js"
export * from "./recurring-reminders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports